import React from 'react'
import { Modal } from 'react-bootstrap'
import ExportsSubView from '../views/subviews/ExportsSubView'
import styled from 'styled-components'

const StyledModal = styled(Modal)`
  .modal-content {
    background: #1a1a1a;
    border: none;
    color: white;
  }

  .modal-header {
    background: linear-gradient(45deg, #402563, #114ee0);
    border-bottom: none;
    padding: 1.25rem 1.5rem;

    .modal-title {
      color: white;
      font-weight: 600;
      font-size: 1.25rem;
    }

    .btn-close {
      color: white;
      filter: brightness(0) invert(1);
    }
  }

  .modal-body {
    padding: 1.5rem;
    background: #2a2a2a;
  }
`

interface ExportModalProps {
  show: boolean
  onHide: () => void
}

const ExportModal: React.FC<ExportModalProps> = ({ show, onHide }) => {
  return (
    <StyledModal show={show} onHide={onHide} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Export Dataset</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ExportsSubView isModal={true} onClose={onHide} />
      </Modal.Body>
    </StyledModal>
  )
}

export default ExportModal
